import { useReducer, useEffect, RefObject, MouseEvent, Reducer } from 'react';
import { useIsomorphicLayoutEffect as useLayoutEffect } from '../../../hooks/useIsomorphicLayoutEffect';
const CarouselTypeActions = {
  setSelectedIndex: 'setSelectedIndex',
  setViewportWidth: 'setViewportWidth',
  setRest: 'setRest'
};
const carouselReducer = (state, action) => {
  const {
    type,
    ...rest
  } = action;
  switch (type) {
    case CarouselTypeActions.setSelectedIndex:
      {
        return {
          ...state,
          selectedIndex: Math.min(Math.max(action.selectedIndex, 0), state.maxLimiter)
        };
      }
    case CarouselTypeActions.setViewportWidth:
      {
        return {
          ...state,
          viewportWidth: action.viewportWidth
        };
      }
    case CarouselTypeActions.setRest:
      {
        return {
          ...state,
          ...rest
        };
      }
    default:
      {
        throw new Error(`Такой операции не существует: ${action.type}`);
      }
  }
};
const useCarouselState = ({
  length,
  selectedIndex = 0,
  slidesToScroll = 1,
  slidesToShow = 1,
  viewportRef
}) => {
  const [state, dispatch] = useReducer(carouselReducer, {
    length,
    maxLimiter: length - Number(slidesToShow),
    selectedIndex: Math.floor(selectedIndex),
    slidesToScroll: Number(slidesToScroll),
    slidesToShow: Number(slidesToShow),
    viewportWidth: 340
  });
  useLayoutEffect(() => {
    dispatch({
      type: CarouselTypeActions.setViewportWidth,
      viewportWidth: viewportRef.current?.clientWidth || 0
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    dispatch({
      type: CarouselTypeActions.setRest,
      length,
      selectedIndex: Math.floor(selectedIndex),
      slidesToScroll: Number(slidesToScroll),
      slidesToShow: Number(slidesToShow)
    });
  }, [length, selectedIndex, slidesToScroll, slidesToShow]);
  const setSelectedIndex = e => {
    dispatch({
      type: CarouselTypeActions.setSelectedIndex,
      selectedIndex: e.target ? parseInt(e.target.value) : Number(e)
    });
  };
  return {
    state,
    setSelectedIndex
  };
};
export default useCarouselState;